// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import DynamicDropdownPresentationPropsDefault from "@insite/mobius/DynamicDropdown/presentationProps";
import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import CaretDown from "@west/XDL/Icons/CaretDown";
import { xBaseTheme } from "@west/XDL/types";
import { color } from "@west/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DynamicDropdownPresentationPropsDefault,
        mergeCss: true,
        iconProps: {
            src: CaretDown,
            size: 10,
            css: css`
                color: ${color("common.ui5")};
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            `,
        },
        cssOverrides: {
            selectedText: css`
                font-size: 14px;
                padding: ${({ _sizeVariant }: any) =>
                    _sizeVariant === "small" ? "1px 24px 1px 11px" : "6px 24px 6px 11px"};
            `,
            dropdownWrapper: css`
                & input[aria-expanded="true"] ~ ${IconWrapper} {
                    transform: rotate(180deg);
                }
                & input:disabled ~ ${IconWrapper} {
                    color: ${color("common.ui8", 0.33)};
                }
            `,
        },
        css: css``,
    },
} as xBaseTheme["dynamicDropdown"];
